import cn from "@/utils/cn"
import { ComponentPropsWithRef } from "react"

type PingIndicatorProps = {} & ComponentPropsWithRef<"span">

const PingIndicator = ({ className, ...otherProps }: PingIndicatorProps) => (
  <span className={cn("relative flex h-2 w-2", className)} {...otherProps}>
    <span className="absolute inline-flex h-full w-full animate-[ping_2s_infinite] rounded-full bg-blue-400 opacity-75"></span>
    <span className="relative inline-flex h-full w-full rounded-full bg-blue-500"></span>
  </span>
)

export default PingIndicator
